import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "@/state/store";
import App from "./App";
import "./styles/global.css";

const root = document.getElementById("app");
if (!root) {
  throw new Error("missing #app root element");
}

createRoot(root).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
);
